import React from 'react'
import Astrea from 'svg/logos/nav-astrea.svg'
import NavSubList from './navSublist'
import Themis from 'svg/logos/nav-themis.svg'
import { Link } from 'gatsby'
import { scrollToId } from '../Helpers/scrollToId'
import { AnchorScrollTo } from '../AnchorScrollTo/anchorScrollTo'

function handleSendGtagEvent() {
	if (typeof window.gtag === 'function') {
		//Send to GA4
		window.gtag('event', 'click-login-astrea', {
			event_type: 'Post',
			non_interaction: true,
			send_to: 'G-V24Z24HJ0H',
		})
	}
}

const NavItem = (props) => {
	const {
		id,
		link,
		title,
		type,
		subItems,
		ulClass,
		btnClass,
		product,
		linkText,
		spanText,
		content,
		navToggle,
		className,
	} = props
	function renderSwitch(param) {
		switch (param) {
			case 'anchor-to':
				return (
					<AnchorScrollTo
						pointerId={link}
						className={`nav_btn ${btnClass}`}
						moreClickActions={navToggle}
					>
						{title}
					</AnchorScrollTo>
				)
			case 'anchor':
				return (
					<a
						key={id}
						id={id}
						className="nav_link"
						rel="noreferrer"
						onClick={(e) => {
							e.preventDefault()
							scrollToId(link)
							navToggle()
						}}
					>
						{title}
					</a>
				)
			case 'internal-link':
				return (
					<Link to={link} key={id} className="nav_link">
						{title}
					</Link>
				)
			case 'link':
				return (
					<a
						href={link}
						key={id}
						className={`nav_link${className ? ` ${className}` : ''}`}
					>
						{title}
					</a>
				)
			case 'sublist':
				return (
					<NavSubList
						type={type}
						link={link}
						title={title}
						subItems={subItems}
						id={id}
						ulClass={typeof ulClass != 'undefined' ? ulClass : ''}
						navToggle={navToggle}
					/>
				)
			case 'btn':
				return (
					<Link
						key={id}
						to={link}
						className={`nav_btn ${btnClass}`}
						onClick={() => {
							if (id === 'login-astrea') {
								handleSendGtagEvent()
							}
						}}
					>
						{title}
					</Link>
				)
			case 'btn-link':
				return (
					<a href={link} key={id} className={`nav_btn ${btnClass}`}>
						{title}
					</a>
				)
			case 'product-card':
				return (
					<Link key={id} to={link} className={`product_card_link`}>
						<div className={`nav_item_product ${product}`}>
							<div className="logo_container">
								<i>{product == 'astrea' ? <Astrea /> : <Themis />}</i>
								<span className="span_text_logo">{spanText}</span>
							</div>
							<h3 className="product_title">{title}</h3>
							<p className="content_text">{content}</p>
							<span className="link_text">{linkText}</span>
						</div>
					</Link>
				)
			case 'product-card-link':
				return (
					<a key={id} href={link} className={`product_card_link`}>
						<div className={`nav_item_product ${product}`}>
							<div className="logo_container">
								<i>{product == 'astrea' ? <Astrea /> : <Themis />}</i>
								<span className="span_text_logo">{spanText}</span>
							</div>
							<h3 className="product_title">{title}</h3>
							<p className="content_text">{content}</p>
							<span className="link_text">{linkText}</span>
						</div>
					</a>
				)
			default:
				return '[ no type set ]'
		}
	}

	return renderSwitch(type)
}

export default NavItem
